import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);

    // Clone the request object
    let newReq = req.clone();

    // Attach the OIDC access token (issued by angular-oauth2-oidc) as a Bearer header.
    // NOTE: use authService.token (== oauthService.getAccessToken()), NOT the old
    // authService.accessToken getter, which read localStorage['accessToken'] — a key that
    // is never populated under the OIDC flow. Reading the wrong key meant NO Authorization
    // header was sent, every protected API call returned 401, and the 401 handler below
    // signed the user out and reloaded — an endless login redirect loop.
    const token = authService.token;
    if ( token && !AuthUtils.isTokenExpired(token) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + token),
        });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) =>
        {
            // Catch "401 Unauthorized" responses
            if ( error instanceof HttpErrorResponse && error.status === 401 )
            {
                // Sign out
                authService.signOut();

                // Reload the app
                location.reload();
            }

            return throwError(error);
        }),
    );
};
